export default "__VITE_ASSET__CVCdPEfh__"